import { toApiSortColumnKey } from "../../screens/Rankings/RankingsUtils";

export { toApiSortColumnKey };

const DEFAULT_SORT_PREFERENCES = {
  sort_by: "wpm_score",
  sort_dir: "desc",
};

export const toApiColumnLayoutKey = (columnKey) =>
  columnKey === "comments" ? "have_comments" : columnKey;

export const fromApiColumnLayoutKey = (columnKey) =>
  columnKey === "have_comments" ? "comments" : columnKey;

export const parseColumnWidth = (width) => {
  if (typeof width === "number" && Number.isFinite(width)) {
    return width;
  }

  if (typeof width === "string") {
    const parsed = Number.parseInt(width, 10);
    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }

  return undefined;
};

export const extractPreferences = (response) => {
  if (!response || typeof response !== "object") {
    return {
      ...DEFAULT_SORT_PREFERENCES,
      column_layout: {},
    };
  }

  const payload =
    response?.data?.preferences ??
    response?.data ??
    response?.preferences ??
    response;

  const columnLayout =
    payload?.column_layout ??
    response?.data?.column_layout ??
    response?.column_layout;

  return {
    sort_by: payload?.sort_by ?? DEFAULT_SORT_PREFERENCES.sort_by,
    sort_dir:
      payload?.sort_dir !== undefined && payload?.sort_dir !== null
        ? payload.sort_dir
        : "",
    column_layout:
      columnLayout && typeof columnLayout === "object" ? columnLayout : {},
  };
};

export const toWidthMap = (columnLayout = {}) => {
  if (!columnLayout || typeof columnLayout !== "object") {
    return {};
  }

  return Object.entries(columnLayout).reduce((accumulator, [columnKey, value]) => {
    const width = parseColumnWidth(value?.width);
    if (Number.isFinite(width)) {
      accumulator[fromApiColumnLayoutKey(columnKey)] = width;
    }
    return accumulator;
  }, {});
};

export const toFrozenMap = (columnLayout = {}) => {
  if (!columnLayout || typeof columnLayout !== "object") {
    return {};
  }

  return Object.entries(columnLayout).reduce((accumulator, [columnKey, value]) => {
    accumulator[fromApiColumnLayoutKey(columnKey)] = Boolean(value?.frozen);
    return accumulator;
  }, {});
};

export const buildColumnLayout = ({
  keysToPersist,
  widthMap,
  renderedWidthMap,
  defaultWidthMap,
  frozenMap = {},
  minWidth,
}) =>
  keysToPersist.reduce((accumulator, columnKey) => {
    if (!columnKey || columnKey === "sort") {
      return accumulator;
    }

    const resolvedWidth = Number.isFinite(widthMap[columnKey])
      ? widthMap[columnKey]
      : Number.isFinite(renderedWidthMap[columnKey])
        ? renderedWidthMap[columnKey]
        : Number.isFinite(defaultWidthMap[columnKey])
          ? defaultWidthMap[columnKey]
          : minWidth;

    const isFrozen = Boolean(frozenMap[columnKey]);

    accumulator[toApiColumnLayoutKey(columnKey)] = {
      width: Math.max(minWidth, Math.round(resolvedWidth)),
      frozen: isFrozen,
    };
    return accumulator;
  }, {});
